<style lang="less">
.firmManagerShow {

}
</style>
<template>
  <!--  经理信息显示组件-->
  <span class="firmManagerShow">
    {{ name }}-{{ phone }}
  </span>
</template>
<script>

export default {
  name: "firmManagerShow",
  data() {
    return {
      obj:{},
    }
  },
  props: {
    name: {default: "name"},
    phone: {default: "phone"},
    id: {},
  },
  created() {
  },
  methods: {
    findById(){
      this.axiosPost("/firmManager/findById.do", {id: this.id}, res => {
        this.$set(this,"obj",res.obj)
        console.log(JSON.stringify(this.obj))
      });
    },
  },
  watch: {
    value2() {
    },
    value() {
    }

  }
  ,
  components: {}
  ,
  mounted: function () {/*页面加载初始化*/
    // this.findById();
  }
}
</script>
